/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from "axios";
import { Configuration } from "../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { Permission } from "../models";
// @ts-ignore
import { ProjectRole } from "../models";
// @ts-ignore
import { UserRole } from "../models";
/**
 * UserRoleApi - axios parameter creator
 * @export
 */
export const UserRoleApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} projectId
     * @param {string} oldUserId
     * @param {string} newUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeOwner: async (
      projectId: string,
      oldUserId: string,
      newUserId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("changeOwner", "projectId", projectId);
      // verify required parameter 'oldUserId' is not null or undefined
      assertParamExists("changeOwner", "oldUserId", oldUserId);
      // verify required parameter 'newUserId' is not null or undefined
      assertParamExists("changeOwner", "newUserId", newUserId);
      const localVarPath =
        `/v1/projects/{projectId}/userroles/changeowner/{oldUserId}/{newUserId}`
          .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
          .replace(`{${"oldUserId"}}`, encodeURIComponent(String(oldUserId)))
          .replace(`{${"newUserId"}}`, encodeURIComponent(String(newUserId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} projectId
     * @param {UserRole} userRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUserRole: async (
      projectId: string,
      userRole: UserRole,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("createUserRole", "projectId", projectId);
      // verify required parameter 'userRole' is not null or undefined
      assertParamExists("createUserRole", "userRole", userRole);
      const localVarPath = `/v1/projects/{projectId}/userroles`.replace(
        `{${"projectId"}}`,
        encodeURIComponent(String(projectId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userRole,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProjectUserRoles: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("deleteProjectUserRoles", "projectId", projectId);
      const localVarPath = `/v1/projects/{projectId}/userroles`.replace(
        `{${"projectId"}}`,
        encodeURIComponent(String(projectId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUserRole: async (
      projectId: string,
      userId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("deleteUserRole", "projectId", projectId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("deleteUserRole", "userId", userId);
      const localVarPath = `/v1/projects/{projectId}/userroles/{userId}`
        .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentPermissions: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getCurrentPermissions", "projectId", projectId);
      const localVarPath = `/v1/projects/{projectId}/userroles/current`.replace(
        `{${"projectId"}}`,
        encodeURIComponent(String(projectId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProjectUserRoles: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getProjectUserRoles", "projectId", projectId);
      const localVarPath = `/v1/projects/{projectId}/userroles`.replace(
        `{${"projectId"}}`,
        encodeURIComponent(String(projectId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} projectId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hasPermission: async (
      projectId: string,
      body: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("hasPermission", "projectId", projectId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists("hasPermission", "body", body);
      const localVarPath =
        `/v1/projects/{projectId}/userroles/permission`.replace(
          `{${"projectId"}}`,
          encodeURIComponent(String(projectId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} userId
     * @param {string} projectId
     * @param {ProjectRole} projectRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserRole: async (
      userId: string,
      projectId: string,
      projectRole: ProjectRole,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("updateUserRole", "userId", userId);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateUserRole", "projectId", projectId);
      // verify required parameter 'projectRole' is not null or undefined
      assertParamExists("updateUserRole", "projectRole", projectRole);
      const localVarPath = `/v1/projects/{projectId}/userroles/{userId}`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
        .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRole,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserRoleApi - functional programming interface
 * @export
 */
export const UserRoleApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserRoleApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} projectId
     * @param {string} oldUserId
     * @param {string} newUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async changeOwner(
      projectId: string,
      oldUserId: string,
      newUserId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.changeOwner(
        projectId,
        oldUserId,
        newUserId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} projectId
     * @param {UserRole} userRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createUserRole(
      projectId: string,
      userRole: UserRole,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createUserRole(
        projectId,
        userRole,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteProjectUserRoles(
      projectId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteProjectUserRoles(
          projectId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteUserRole(
      projectId: string,
      userId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserRole(
        projectId,
        userId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCurrentPermissions(
      projectId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<Permission>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getCurrentPermissions(
          projectId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProjectUserRoles(
      projectId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<UserRole>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getProjectUserRoles(projectId, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} projectId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hasPermission(
      projectId: string,
      body: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.hasPermission(
        projectId,
        body,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} userId
     * @param {string} projectId
     * @param {ProjectRole} projectRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateUserRole(
      userId: string,
      projectId: string,
      projectRole: ProjectRole,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserRole(
        userId,
        projectId,
        projectRole,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * UserRoleApi - factory interface
 * @export
 */
export const UserRoleApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserRoleApiFp(configuration);
  return {
    /**
     *
     * @param {string} projectId
     * @param {string} oldUserId
     * @param {string} newUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeOwner(
      projectId: string,
      oldUserId: string,
      newUserId: string,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .changeOwner(projectId, oldUserId, newUserId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} projectId
     * @param {UserRole} userRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUserRole(
      projectId: string,
      userRole: UserRole,
      options?: any
    ): AxiosPromise<string> {
      return localVarFp
        .createUserRole(projectId, userRole, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProjectUserRoles(
      projectId: string,
      options?: any
    ): AxiosPromise<boolean> {
      return localVarFp
        .deleteProjectUserRoles(projectId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUserRole(
      projectId: string,
      userId: string,
      options?: any
    ): AxiosPromise<boolean> {
      return localVarFp
        .deleteUserRole(projectId, userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentPermissions(
      projectId: string,
      options?: any
    ): AxiosPromise<Array<Permission>> {
      return localVarFp
        .getCurrentPermissions(projectId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProjectUserRoles(
      projectId: string,
      options?: any
    ): AxiosPromise<Array<UserRole>> {
      return localVarFp
        .getProjectUserRoles(projectId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} projectId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hasPermission(
      projectId: string,
      body: string,
      options?: any
    ): AxiosPromise<boolean> {
      return localVarFp
        .hasPermission(projectId, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} userId
     * @param {string} projectId
     * @param {ProjectRole} projectRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserRole(
      userId: string,
      projectId: string,
      projectRole: ProjectRole,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateUserRole(userId, projectId, projectRole, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for changeOwner operation in UserRoleApi.
 * @export
 * @interface UserRoleApiChangeOwnerRequest
 */
export interface UserRoleApiChangeOwnerRequest {
  /**
   *
   * @type {string}
   * @memberof UserRoleApiChangeOwner
   */
  readonly projectId: string;

  /**
   *
   * @type {string}
   * @memberof UserRoleApiChangeOwner
   */
  readonly oldUserId: string;

  /**
   *
   * @type {string}
   * @memberof UserRoleApiChangeOwner
   */
  readonly newUserId: string;
}

/**
 * Request parameters for createUserRole operation in UserRoleApi.
 * @export
 * @interface UserRoleApiCreateUserRoleRequest
 */
export interface UserRoleApiCreateUserRoleRequest {
  /**
   *
   * @type {string}
   * @memberof UserRoleApiCreateUserRole
   */
  readonly projectId: string;

  /**
   *
   * @type {UserRole}
   * @memberof UserRoleApiCreateUserRole
   */
  readonly userRole: UserRole;
}

/**
 * Request parameters for deleteProjectUserRoles operation in UserRoleApi.
 * @export
 * @interface UserRoleApiDeleteProjectUserRolesRequest
 */
export interface UserRoleApiDeleteProjectUserRolesRequest {
  /**
   *
   * @type {string}
   * @memberof UserRoleApiDeleteProjectUserRoles
   */
  readonly projectId: string;
}

/**
 * Request parameters for deleteUserRole operation in UserRoleApi.
 * @export
 * @interface UserRoleApiDeleteUserRoleRequest
 */
export interface UserRoleApiDeleteUserRoleRequest {
  /**
   *
   * @type {string}
   * @memberof UserRoleApiDeleteUserRole
   */
  readonly projectId: string;

  /**
   *
   * @type {string}
   * @memberof UserRoleApiDeleteUserRole
   */
  readonly userId: string;
}

/**
 * Request parameters for getCurrentPermissions operation in UserRoleApi.
 * @export
 * @interface UserRoleApiGetCurrentPermissionsRequest
 */
export interface UserRoleApiGetCurrentPermissionsRequest {
  /**
   *
   * @type {string}
   * @memberof UserRoleApiGetCurrentPermissions
   */
  readonly projectId: string;
}

/**
 * Request parameters for getProjectUserRoles operation in UserRoleApi.
 * @export
 * @interface UserRoleApiGetProjectUserRolesRequest
 */
export interface UserRoleApiGetProjectUserRolesRequest {
  /**
   *
   * @type {string}
   * @memberof UserRoleApiGetProjectUserRoles
   */
  readonly projectId: string;
}

/**
 * Request parameters for hasPermission operation in UserRoleApi.
 * @export
 * @interface UserRoleApiHasPermissionRequest
 */
export interface UserRoleApiHasPermissionRequest {
  /**
   *
   * @type {string}
   * @memberof UserRoleApiHasPermission
   */
  readonly projectId: string;

  /**
   *
   * @type {string}
   * @memberof UserRoleApiHasPermission
   */
  readonly body: string;
}

/**
 * Request parameters for updateUserRole operation in UserRoleApi.
 * @export
 * @interface UserRoleApiUpdateUserRoleRequest
 */
export interface UserRoleApiUpdateUserRoleRequest {
  /**
   *
   * @type {string}
   * @memberof UserRoleApiUpdateUserRole
   */
  readonly userId: string;

  /**
   *
   * @type {string}
   * @memberof UserRoleApiUpdateUserRole
   */
  readonly projectId: string;

  /**
   *
   * @type {ProjectRole}
   * @memberof UserRoleApiUpdateUserRole
   */
  readonly projectRole: ProjectRole;
}

/**
 * UserRoleApi - object-oriented interface
 * @export
 * @class UserRoleApi
 * @extends {BaseAPI}
 */
export class UserRoleApi extends BaseAPI {
  /**
   *
   * @param {UserRoleApiChangeOwnerRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */
  public changeOwner(
    requestParameters: UserRoleApiChangeOwnerRequest,
    options?: any
  ) {
    return UserRoleApiFp(this.configuration)
      .changeOwner(
        requestParameters.projectId,
        requestParameters.oldUserId,
        requestParameters.newUserId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UserRoleApiCreateUserRoleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */
  public createUserRole(
    requestParameters: UserRoleApiCreateUserRoleRequest,
    options?: any
  ) {
    return UserRoleApiFp(this.configuration)
      .createUserRole(
        requestParameters.projectId,
        requestParameters.userRole,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UserRoleApiDeleteProjectUserRolesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */
  public deleteProjectUserRoles(
    requestParameters: UserRoleApiDeleteProjectUserRolesRequest,
    options?: any
  ) {
    return UserRoleApiFp(this.configuration)
      .deleteProjectUserRoles(requestParameters.projectId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UserRoleApiDeleteUserRoleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */
  public deleteUserRole(
    requestParameters: UserRoleApiDeleteUserRoleRequest,
    options?: any
  ) {
    return UserRoleApiFp(this.configuration)
      .deleteUserRole(
        requestParameters.projectId,
        requestParameters.userId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UserRoleApiGetCurrentPermissionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */
  public getCurrentPermissions(
    requestParameters: UserRoleApiGetCurrentPermissionsRequest,
    options?: any
  ) {
    return UserRoleApiFp(this.configuration)
      .getCurrentPermissions(requestParameters.projectId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UserRoleApiGetProjectUserRolesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */
  public getProjectUserRoles(
    requestParameters: UserRoleApiGetProjectUserRolesRequest,
    options?: any
  ) {
    return UserRoleApiFp(this.configuration)
      .getProjectUserRoles(requestParameters.projectId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UserRoleApiHasPermissionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */
  public hasPermission(
    requestParameters: UserRoleApiHasPermissionRequest,
    options?: any
  ) {
    return UserRoleApiFp(this.configuration)
      .hasPermission(
        requestParameters.projectId,
        requestParameters.body,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UserRoleApiUpdateUserRoleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */
  public updateUserRole(
    requestParameters: UserRoleApiUpdateUserRoleRequest,
    options?: any
  ) {
    return UserRoleApiFp(this.configuration)
      .updateUserRole(
        requestParameters.userId,
        requestParameters.projectId,
        requestParameters.projectRole,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
